import { useLang } from "./i18n";

const ITEMS = {
  en: [["Discover", "#1F5BFF"], ["Understand", "#7C3AED"], ["Grow", "#3AA64B"], ["Choose", "#F5A524"], ["Succeed", "#E84393"]],
  hi: [["खोजें", "#1F5BFF"], ["समझें", "#7C3AED"], ["बढ़ें", "#3AA64B"], ["चुनें", "#F5A524"], ["सफल हों", "#E84393"]],
};

export default function Marquee() {
  const { lang } = useLang();
  const row = [...ITEMS[lang], ...ITEMS[lang], ...ITEMS[lang]];
  return (
    <div className="border-y border-ink/10 py-7 overflow-hidden bg-cream/50" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map(([word, color], i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-bold text-2xl sm:text-4xl tracking-tight px-8" style={{ color: i % 2 ? color : "#0A1633" }}>
                  {word}
                </span>
                <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0" fill={color} aria-hidden>
                  <path d="M12 0c.8 6.4 5.6 11.2 12 12-6.4.8-11.2 5.6-12 12-.8-6.4-5.6-11.2-12-12C6.4 11.2 11.2 6.4 12 0z" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
